import React from 'react';

export default function Logo({ size = 32, tone = 'ink' }) {
  const inkColor = tone === 'paper' ? '#f4efe6' : '#0f1a2a';
  const paperColor = tone === 'paper' ? '#0f1a2a' : '#f4efe6';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
        <defs>
          <linearGradient id="zlogo" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor={inkColor} />
            <stop offset="1" stopColor="#c4602e" />
          </linearGradient>
        </defs>
        <rect width="64" height="64" rx="12" fill="url(#zlogo)" />
        <g fill={paperColor}>
          <rect x="14" y="22" width="8" height="30" rx="1" />
          <rect x="26" y="14" width="12" height="38" rx="1" />
          <rect x="42" y="26" width="8" height="26" rx="1" />
          <rect x="29" y="18" width="2" height="2" />
          <rect x="33" y="18" width="2" height="2" />
          <rect x="29" y="24" width="2" height="2" />
          <rect x="33" y="24" width="2" height="2" />
          <rect x="29" y="30" width="2" height="2" />
          <rect x="33" y="30" width="2" height="2" />
          <rect x="29" y="36" width="2" height="2" />
          <rect x="33" y="36" width="2" height="2" />
          <rect x="16" y="28" width="2" height="2" />
          <rect x="16" y="34" width="2" height="2" />
          <rect x="16" y="40" width="2" height="2" />
          <rect x="44" y="32" width="2" height="2" />
          <rect x="44" y="38" width="2" height="2" />
          <rect x="44" y="44" width="2" height="2" />
        </g>
      </svg>
      <span className="font-display" style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.02em', color: tone === 'paper' ? '#f4efe6' : '#0f1a2a' }}>Zantravina</span>
    </span>
  );
}
